import { useLang, LANGS } from '@/i18n/LanguageContext';
import { Globe } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1.5 rounded-full transition-colors ${
          compact
            ? 'px-2 py-1 text-xs text-gray-300 hover:text-yellow-400'
            : 'px-3 py-1.5 text-sm text-gray-700 hover:text-orange-600 hover:bg-orange-50'
        }`}
        aria-label={t('lang_label')}
        data-testid="lang-switcher-btn"
      >
        <Globe size={14} />
        <span className="font-semibold">{current.label}</span>
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 min-w-[140px] bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50"
          data-testid="lang-dropdown"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`block w-full text-left px-4 py-2.5 text-sm transition-colors ${
                l.code === lang
                  ? 'bg-orange-50 text-orange-600 font-semibold'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="mr-2 font-bold">{l.label}</span>
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
